<div class="modal-header">
    <h4 class="modal-title pull-left">Intend or Decline to Participate</h4>
    <button type="button" class="close" aria-label="Close" (click)="bsModalRef?.hide()">
        <span aria-hidden="true">&times;</span>
    </button>
</div>
<div class="modal-body">
    <section class="prInitiator">
        <div class="d-flex flex-column mb-4 mt-1">
            <ul>
                <li>
                    <p>If you plan to participate in the bidding, click <b>Intend to Participate</b></p>
                </li>
                <li>
                    <p>If you do not plan to participate in the bidding, click <b>Decline to Participate</b></p>
                </li>
            </ul>
        </div>
    </section>
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-outline-primary me-2" (click)="submit('intend')">
        INTEND TO PARTICIPATE
    </button>
    <button type="button" class="btn btn-outline-primary me-2" (click)="submit('decline')">
        DECLINE TO PARTICIPATE
    </button>
</div>